import { render, staticRenderFns } from "./ModalHistoricoFinalizacoes.vue?vue&type=template&id=200e4294&scoped=true"
import script from "./ModalHistoricoFinalizacoes.vue?vue&type=script&lang=js"
export * from "./ModalHistoricoFinalizacoes.vue?vue&type=script&lang=js"
import style0 from "./ModalHistoricoFinalizacoes.vue?vue&type=style&index=0&id=200e4294&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200e4294",
  null
  
)

export default component.exports